import store from "@/store/store";

export default [
    {

        path: '/unsubscribe-confirmation',
        name: 'unsubscribe-confirmation',
        props: true,
        component: () => import('@/views/EmailUnsubscribeLanding.vue'),
    },
    {
        path: '/checkout/quote/:code/:signature',
        name: 'quoteCheckout',
        props: true,
        component: () => import('@/views/checkout/QuoteCheckoutLanding.vue'),
    },
    {
        path: '/login/google',
        name: 'google-oauth-callback',
        component: () => import('@/views/auth/ProviderAuthRedirect'),
    },
    {
        path: '/reset-password/:code',
        name: 'reset-password',
        props: true,
        component: () => import('@/views/auth/ResetPassword.vue'),
    },
    {
        path: '/reset-password/:code',
        name: 'reset-password',
        props: true,
        component: () => import('@/views/ResetPassword.vue'),
    },
    {
        path: '/adoption/contact/:customerId?/:companyId?',
        name: 'adoption-contact',
        props: true,
        component: () => import('../views/adoptions/ContactForm'),
        meta: {
            title: 'Studies Weekly Contact Form',
            header: 'Contact Information'
        }
    },
    {
        path: '/adoption/:customerId',
        name: 'adoption',
        props: true,
        component: () => import('../views/adoptions/Index.vue'),
        children: [
            {
                path: 'view/',
                alias: ['/adoption/view/:customerId', '/'],
                name: 'adoption-status',
                component: () => import('../views/adoptions/AdoptionStatus'),
                props: true,
                meta: {
                    title: 'Studies Weekly Adoption',
                    header: 'Adoption Status'
                }
            },
            {
                path: 'previous/',
                name: 'adoption-previous',
                component: () => import('../views/adoptions/PreviousYears'),
                props: true,
                meta: {
                    title: 'Studies Weekly Adoption',
                    header: 'Adoption Status'
                }
            },
            {
                path: 'contact/:companyId?',
                name: 'adoption-contact',
                props: true,
                component: () => import('../views/adoptions/ContactForm'),
                meta: {
                    title: 'Studies Weekly Contact Form',
                    header: 'Contact Information'
                }
            },
            {
                path: 'update/',
                name: 'adoption-update',
                props: true,
                component: () => import('../views/adoptions/UpdateAdoption'),
                meta: {
                    title: 'Studies Weekly Update Form',
                    header: 'Update Information Form'
                }
            },
        ]
    },
    {
        path: '/order-form/:stateId?',
        name: 'order-forms',
        component: () => import('@/views/OrderForm.vue')
    },
    {
        path: '/sd-order-form/',
        name: 'sd-order-forms',
        component: () => import('@/views/SDOrderForm/SDOrderForm.vue')
    },
    {
        path: '*',
        name: 'error-404',
        component: () => import('@/views/Error404.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/auth/Login.vue'),
        meta: {
            title: 'Studies Weekly Store - Login',
            auth: false
        },
        beforeEnter: (to, from, next) => {

            let target = to.query
            let source = {};
            if (from.fullPath.indexOf('reset-password') === -1) {
                source.redirect = from.fullPath;
            }

            Object.assign(target, source)

            next()
        }
    },
    {
        path: '/404',
        name: 'error404',
        component: () => import('@/views/Error404.vue'),
        meta: {
            title: 'Studies Weekly Store - 404'
        }
    },
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: {
            title: 'Studies Weekly Store'
        }
    },
    {
        path: '/cart',
        name: 'cart',
        component: () => import('@/views/Cart.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Cart',
        },
    },
    {
        path: '/cart/recover/:token',
        name: 'recover-cart',
        component: () => import('@/views/RecoverCart.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Cart',
        }
    },
    {
        path: '/checkout',
        name: 'checkout',
        component: () => import('@/views/checkout/Checkout.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Checkout',
        },
        beforeEnter: (to, from, next) => {
            // No cart
            // let cart = store.state.products;
            // if (!cart || !cart.length) {
            //     next({name: 'cart'});
            //     return;
            // }

            // Authenticate
            let token = localStorage['laravel-vue-spa']
            let credentials = store.state.checkout.credentials

            if (
                !token &&
                (!credentials || (!credentials.email && !credentials.password))
            ) {
                next({
                    name: 'loginToCheckout',
                    query: {
                        redirect: '/checkout'
                    }
                })
            } else {
                next()
            }
        }
    },
    {
        path: '/checkout/login',
        name: 'loginToCheckout',
        component: () => import(/* webpackChunkName: "checkout" */'@/views/checkout/LoginToCheckout.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Login',
        }
    },
    {
        path: '/checkout/success/:order_number',
        name: 'checkoutSuccess',
        component: () => import(/* webpackChunkName: "checkout" */'@/views/checkout/CheckoutSuccess.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Success',
        }
    },
    {
        path: '/t/:affiliate_code',
        name: 'my-affiliate-page',
        component: () => import('@/views/affiliate/MyAffiliatePage.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - My Affiliate Page',
        }
    },
    {
        path: '/order_status/:access_key/:invoice_id',
        name: 'orderStatus',
        component: () => import('@/views/PackageStatus.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - OrderDetails Status'
        }
    },
    {
        path: '/order_status/:access_key/:invoice_id(\\d+)/:sub_order_id',
        name: 'orderStatus',
        component: () => import('@/views/PackageStatus.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - OrderDetails Status'
        }
    },
];